import { createEffect } from 'effector';
import { Reseller, SearchResultItem as SplSearchResultItem, SplFormData } from '../../pages/SinglePieceLookupPage/types';
import { trimObject } from '../../util/AddressUtils';
import { ghApi } from '../DataService';
import { AcsEvent, MailPiece, Scan } from './types';

const getMailDetailsFx = createEffect<
  {
    ghsClientId: string;
    customerId: string;
    imb: string;
    pkgId: string;
    mailDate: string;
  },
  MailPiece
>(async params => {
  return ghApi.get('/spl/mailingDetails', { params }).then(res => trimObject(res.data) as MailPiece);
});

const getAcsEventsFx = createEffect<
  {
    ghsClientId: string;
    customerId: string;
    trackCode: string;
    pkgId: string;
    mailDate: string;
  },
  AcsEvent[]
>(async params => {
  return ghApi.get('/spl/acsEvents', { params }).then(res => res.data.map((acsEvent: AcsEvent) => trimObject(acsEvent) as AcsEvent));
});

const getScanDataFx = createEffect<
  {
    ghsClientId: string;
    customerId: string;
    trackCode: string;
    pkgId: string;
    mailDate: string;
  },
  Scan[]
>(async params => {
  return ghApi.get('/spl/scans', { params }).then(res => res.data.map((scan: Scan) => trimObject(scan) as Scan));
});

const getSplResultsFx = createEffect<SplFormData, SplSearchResultItem[]>(async params => {
  return ghApi
    .get('/spl/search', {
      params: {
        ...params,
        origin: false
      }
    })
    .then(res => res.data.map(trimObject));
});

const getResellerListFx = createEffect<{ startDate: string; endDate: string }, Reseller[]>(async ({ startDate, endDate }) => {
  return ghApi
    .get('/spl/resellers', {
      params: {
        startDate,
        endDate
      }
    })
    .then(res => res.data.map((reseller: Reseller) => trimObject(reseller) as Reseller));
});

export const $$splService = {
  getMailDetailsFx,
  getAcsEventsFx,
  getScanDataFx,
  getSplResultsFx,
  getResellerListFx
};
